import {gn, getUrlVars, newHTML} from '../utils/lib';
import IO from '../tablet/IO';
import MediaLib from '../tablet/MediaLib';
import Localization from '../utils/Localization';

let place;
const HOSTED_INTRO_VIDEO = 'assets/lobby/intro.mp4';
const HOSTED_INTRO_POSTER = 'assets/lobby/poster.png';

function resolveGettingStartedVideoPath () {
    try {
        const isHostedWebPage = /^https?:$/i.test(window.location.protocol);
        if (isHostedWebPage) {
            return HOSTED_INTRO_VIDEO;
        }

        if (window.AndroidInterface &&
            typeof window.AndroidInterface.scratchjr_getgettingstartedvideopath === 'function') {
            const nativePath = window.AndroidInterface.scratchjr_getgettingstartedvideopath();
            if (typeof nativePath === 'string' && nativePath.trim()) {
                return nativePath;
            }
        }
    } catch (e) {
        console.warn('Unable to resolve native getting started video path, using hosted fallback.', e);
    }

    return HOSTED_INTRO_VIDEO;
}

function applyGettingStartedVideoSource (videoObj) {
    if (!videoObj) {
        return;
    }

    videoObj.type = 'video/mp4';
    videoObj.playsInline = true;
    videoObj.preload = 'metadata';
    videoObj.src = resolveGettingStartedVideoPath();
    if (typeof videoObj.load === 'function') {
        videoObj.load();
    }
}

function startGettingStartedVideo (videoObj, restartFromBeginning) {
    if (!videoObj) {
        return null;
    }

    videoObj.style.display = 'block';
    videoObj.controls = true;
    if (restartFromBeginning) {
        try {
            videoObj.currentTime = 0;
        } catch (_) {}
    }

    if (typeof videoObj.play !== 'function') {
        return null;
    }

    try {
        const playPromise = videoObj.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function (error) {
                console.warn('Unable to start getting started video playback.', error);
            });
        }
        return playPromise;
    } catch (error) {
        console.warn('Unable to start getting started video playback.', error);
    }

    return null;
}

function installGettingStartedPlaybackOverlay (videoObj) {
    if (!videoObj || !videoObj.parentNode) {
        return;
    }

    const container = videoObj.parentNode;
    const overlay = newHTML('button', 'gsvideostart', container);
    overlay.type = 'button';
    overlay.setAttribute('aria-label', 'Play getting started video');
    newHTML('span', 'gsvideostarticon', overlay);
    videoObj.controls = false;

    let removed = false;
    function removeOverlay () {
        if (removed) {
            return;
        }
        removed = true;
        if (overlay.parentNode) {
            overlay.parentNode.removeChild(overlay);
        }
    }

    function beginPlayback (evt) {
        if (evt) {
            evt.preventDefault();
            evt.stopPropagation();
        }

        const playPromise = startGettingStartedVideo(videoObj, false);
        removeOverlay();
        return playPromise;
    }

    overlay.onclick = beginPlayback;
    overlay.ontouchend = beginPlayback;
    videoObj.addEventListener('play', removeOverlay, {once: true});
}

export function gettingStartedMain () {
    gn('closeHelp').onclick = gettingStartedCloseMe;
    gn('closeHelp').ontouchstart = gettingStartedCloseMe;
    var videoObj = gn('myVideo');
    videoObj.poster = HOSTED_INTRO_POSTER;
    var image = document.createElement('img');
    image.src = videoObj.poster;
    image.onload = function () {
        videoObj.style.display = 'block';
    };
    image.onerror = function () {
        videoObj.style.display = 'block';
    };
    applyGettingStartedVideoSource(videoObj);
    installGettingStartedPlaybackOverlay(videoObj);
    videoObj.onerror = function () {
        if (videoObj.getAttribute('src') !== HOSTED_INTRO_VIDEO) {
            videoObj.src = HOSTED_INTRO_VIDEO;
            if (typeof videoObj.load === 'function') {
                videoObj.load();
            }
        }
    };
    var urlvars = getUrlVars();
    place = urlvars['place'];
    document.ontouchmove = function (e) {
        if (videoObj && videoObj.parentNode && e && e.target && videoObj.parentNode.contains(e.target)) {
            return true;
        }
        e.preventDefault();
        return false;
    };

    // Render sample projects gallery below the video if samples are available
    try {
        renderSampleGallery();
    } catch (e) {
        // Non-fatal: gallery is optional for this page
        console.warn('Sample gallery render failed:', e);
    }
}


function gettingStartedCloseMe () {
    window.location.href = 'home.html?place=' + place;
}

// Build a lightweight sample gallery on the getting started page
function renderSampleGallery () {
    var grid = gn('gs-sample-grid');
    var header = gn('gs-samples-header');
    if (!grid || !header) {
        return; // container not present
    }
    // Localize header label
    try { header.textContent = Localization.localize('SAMPLE_PROJECTS'); } catch (_) {}

    // No samples configured — leave section hidden
    var files = MediaLib.samples || [];
    if (!files || files.length === 0) {
        gn('gs-samples').style.display = 'none';
        return;
    }

    // Helper to create a tile using lobby thumb visuals
    function createTile (index, name, md5, openRef) {
        var tb = newHTML('div', 'samplethumb', grid);
        tb.setAttribute('id', 'sample-' + index);
        tb.type = 'samplethumb';
        var mt = newHTML('div', 'thumb pos' + (index % 8), tb);
        newHTML('div', 'woodframe', mt);
        var cnv = newHTML('div', 'sampleicon', mt);
        if (md5) {
            cnv.style.backgroundImage = "url('" + md5 + "')";
        }
        var nameEl = newHTML('p', undefined, tb);
        var localized = name ? Localization.localize('SAMPLE_' + name) : name;
        // Microsoft UX: No fallback placeholder names to prevent flash
        nameEl.textContent = (localized && localized !== 'Sample' && !localized.startsWith('Sample ')) ? localized :
                             (name && name !== 'Sample' && !name.startsWith('Sample ')) ? name : '';

        var nav = function (e) {
            e.preventDefault();
            e.stopPropagation();
            // Prefer DB project id if seeded
            var mapped = (window.__SAMPLE_ID_MAP__ && openRef) ? window.__SAMPLE_ID_MAP__[openRef] : null;
            var pmd5 = mapped || openRef;
            // Always open in storyStarter mode (forces clone on first change)
            window.location.href = 'editor.html?pmd5=' + encodeURIComponent(pmd5) + '&mode=storyStarter';
        };
        tb.onclick = nav;
        tb.ontouchstart = nav;
    }

    // Fetch and render each configured sample
    files.forEach(function (url, index) {
        IO.requestFromServer(url, function (str) {
            try {
                var parsed = IO.parseProjectData(JSON.parse(str)[0]);
                var name = parsed.name;
                // Thumbnail image (if present) or fallback to the page background SVG
                var thumb = parsed.thumbnail && parsed.thumbnail.md5 ? parsed.thumbnail.md5 : null;
                var openRef = url; // pass URL so IO.getObject fetches the sample file
                // If thumbnail looks unavailable (e.g., samples/star.png not shipped), try the page bg
                if (!thumb && parsed.json && parsed.json['page 1'] && parsed.json['page 1'].md5) {
                    thumb = parsed.json['page 1'].md5;
                }
                createTile(index, name, thumb, openRef);
            } catch (e) {
                console.warn('Failed to parse sample file', url, e);
            }
        });
    });

    // Add a Quick Intro tile that scrolls to and plays the video
    var qIndex = files.length;
    var quickTile = newHTML('div', 'samplethumb', grid);
    quickTile.setAttribute('id', 'sample-' + qIndex);
    quickTile.type = 'samplethumb';
    var qThumb = newHTML('div', 'thumb pos' + (qIndex % 8), quickTile);
    newHTML('div', 'woodframe', qThumb);
    var qArt = newHTML('div', 'sampleicon', qThumb);
    qArt.style.backgroundImage = "url('assets/lobby/movielaunch.svg')";
    var qLabel = newHTML('p', undefined, quickTile);
    try { qLabel.textContent = Localization.localize('SAMPLE_Quick Intro'); } catch (_) { qLabel.textContent = 'Quick Intro'; }
    var playVideo = function (e) {
        e.preventDefault();
        e.stopPropagation();
        try {
            var v = gn('myVideo');
            if (v) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                startGettingStartedVideo(v, true);
            }
        } catch (_) {}
    };
    quickTile.onclick = playVideo;
    quickTile.ontouchstart = playVideo;
}
